/**
 * kör-69 #19 (2a): a gépkategória-admin és az óradíj-konfig KÖZÖS szerep-listája.
 *
 * Külön fájlban, mert a `react-refresh/only-export-components` szabály szerint a
 * komponens-fájl csak komponenst exportálhat — és mert így a lista a teszteknek
 * is importálható a komponens betöltése nélkül.
 *
 * 🔴 A lista DASHBOARD-szerepneveket tartalmaz, NEM BE-szerepeket. A FE-n a
 * boltvezető neve `'STORE_MANAGER'` (`backend-role-map:40` BOLTVEZETO →
 * STORE_MANAGER). Aki ide `'BOLTVEZETO'`-t ír, a jogosult szerepet zárja ki —
 * némán. A `RequireDashboardRole.spec` mutáció-kontrollja pontosan ezt méri.
 */
import type { UserRole } from '@/features/dashboard/lib/widget-registry';

export const CATEGORY_ADMIN_ROLES: UserRole[] = ['STORE_MANAGER', 'ADMIN', 'SUPER_ADMIN'];
